import Box from '@mui/material/Box';

/** Initials avatar in primary container (design sizes 28–80). */
export function InitialsAvatar({
  initials,
  size = 36,
  tone = 'primary',
}: {
  initials: string;
  size?: number;
  tone?: 'primary' | 'neutral';
}) {
  return (
    <Box
      component="span"
      aria-hidden
      sx={(t) => ({
        width: size,
        height: size,
        borderRadius: size / 2,
        flexShrink: 0,
        bgcolor: tone === 'primary' ? t.vars.palette.primary.container : t.vars.palette.surface.containerHigh,
        color: tone === 'primary' ? t.vars.palette.primary.onContainer : t.vars.palette.text.secondary,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: Math.round(size * 0.36),
        fontWeight: 700,
      })}
    >
      {initials}
    </Box>
  );
}
